/**
 * IMPORTANT!!!
 * This is an autogenerated file from the Vite layouts-loader plugin.
 * It will be overwritten on every build, do not modify it manually.
 */

import { type App, defineAsyncComponent } from 'vue';

export const setupLayoutComponents = (app: App) => {
  app.component(
    'LayoutApprovalsSettingsDefault',
    defineAsyncComponent(() => import('@/approvals/layouts/layout-approvals-settings-default.vue'))
  );

  app.component(
    'LayoutCompCycle',
    defineAsyncComponent(() => import('@/ccpv2/layouts/layout-comp-cycle.vue'))
  );

  app.component(
    'LayoutDefault',
    defineAsyncComponent(() => import('@/layouts/layout-default.vue'))
  );

  app.component(
    'LayoutEmpty',
    defineAsyncComponent(() => import('@/layouts/layout-empty.vue'))
  );

  app.component(
    'LayoutLogin',
    defineAsyncComponent(() => import('@/login/layouts/layout-login.vue'))
  );

  app.component(
    'LayoutOffersDefault',
    defineAsyncComponent(() => import('@/offers/layouts/layout-offers-default.vue'))
  );

  app.component(
    'DefaultLayout',
    defineAsyncComponent(() => import('@/people/layouts/default-layout.vue'))
  );

  app.component(
    'PeopleSettingsLayout',
    defineAsyncComponent(() => import('@/people/layouts/people-settings-layout.vue'))
  );

  app.component(
    'LayoutSettingsDefault',
    defineAsyncComponent(() => import('@/settings/layouts/layout-settings-default.vue'))
  );

  app.component(
    'LayoutVisualOffersEmpty',
    defineAsyncComponent(() => import('@/visual-offers/layouts/layout-visual-offers-empty.vue'))
  );
};
